export const toDataUrl = async (blob: Blob): Promise<string | ArrayBuffer> => {
  const reader = new FileReader()
  reader.readAsDataURL(blob)
  return new Promise((resolve, reject) => {
    reader.onloadend = function () {
      resolve(reader.result)
    }
  })
}
